import React from "react";
import { ExlyModal } from "features/Common/modules/ExlyModal/ExlyModal";
import { useDeleteConfirmationModal } from "./utils/hooks/useDeleteConfirmationModal";

export const DeleteConfirmationModal = () => {
  const { open, setOpen, handleSubmit } = useDeleteConfirmationModal();
  return (
    <ExlyModal
      title="Are you sure you want to delete"
      open={open}
      onClose={() => setOpen(false)}
      primaryBtnText="Delete Contacts"
      onPrimaryBtnClick={handleSubmit}
      showSecondaryBtn
      onSecondaryBtnClick={() => setOpen(false)}
      modal_props={{
        primaryBtnClassName: "!tw-w-full !tw-bg-[#BA030F]",
        secondaryBtnClassName:
          "!tw-font-medium !tw-border-[1.5px] !tw-border-solid !tw-rounded-[5px] !tw-border-[#272522] !tw-w-full hover:!tw-bg-transparent",
      }}
      primaryBtnProps={{
        buttonWrapperClassName: "!tw-w-full",
      }}
      secondaryBtnProps={{
        buttonWrapperClassName: "!tw-w-full",
      }}
      className="!tw-p-0"
    >
      <div className="tw-p-[16px]">
        <span className="tw-font-bold tw-text-[#BA030F]">
          This action can’t be reverted
        </span>
        , i.e Once deleted, the profile(s) can’t be recovered. Ensure that you
        are deleting the correct profile(s).
      </div>
    </ExlyModal>
  );
};
